export const isOdd = num => num % 2 === 1;

export const isNumber = value => typeof value === 'number' && !isNaN(value);
